// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1702":"4d34c113","7222":"18394c63","7937":"de4f6177"}[chunkId] || chunkId) + "." + {"1702":"1311a250a1e7b14e","5763":"6fbc0e94569381a5","6893":"d35f5b0b007d4b0b","6974":"6556e1b3b67c9d7b","7222":"7839f50bb8a6fe1d","7937":"345f8675741f292d"}[chunkId] + ".js";
};